/** Catégories boutique locale (alignées sur Categories.jsx). */
export const LOCAL_CATEGORIES = [
  { id: 'mode', label: 'Mode & Accessoires', icon: '👗' },
  { id: 'electronique', label: 'Électronique', icon: '📱' },
  { id: 'maison', label: 'Maison & Déco', icon: '🏠' },
  { id: 'beaute', label: 'Beauté & Santé', icon: '💄' },
  { id: 'sport', label: 'Sport & Loisirs', icon: '⚽' },
  { id: 'alimentation', label: 'Alimentation', icon: '🍎' },
  { id: 'enfants', label: 'Enfants & Bébés', icon: '👶' },
  { id: 'autre', label: 'Autre', icon: '📦' },
];

export function getCategoryLabel(id) {
  return LOCAL_CATEGORIES.find((c) => c.id === id)?.label || id || 'Autre';
}
